/* Refresh only server-marked customer UI. Never evaluate scripts from a response. */
(() => {
  let pending;

  function readState(html) {
    const node = html.getElementById('NeCustomerState');
    const state = node && JSON.parse(node.textContent);
    if (!html.body.classList.contains('is-logged') ||
        !Number.isSafeInteger(state?.customer?.id) || state.customer.id <= 0) {
      throw new Error('Customer session was not confirmed');
    }
    return state;
  }

  async function refreshPage() {
    const url = new URL(window.location.href);
    url.searchParams.delete('auth');
    // Some product selectors keep the selected variant in the form, not the URL.
    if (url.pathname.includes('/products/')) {
      const variant = document.querySelector('main product-form [name="id"]')?.value;
      if (variant) url.searchParams.set('variant', variant);
    }
    const response = await fetch(url, {
      credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(30000),
    });
    if (!response.ok || new URL(response.url).origin !== url.origin) {
      throw new Error('Unable to refresh customer state');
    }
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const state = readState(html);
    const updates = Array.from(document.querySelectorAll('[data-auth-refresh][id], .ne-auth-section[id]'), (current) => {
      const next = html.getElementById(current.id);
      if (!next || (!next.hasAttribute('data-auth-refresh') && !next.classList.contains('ne-auth-section'))) {
        throw new Error('Customer UI is missing');
      }
      // Scripts remain inert. Components initialize through their normal lifecycle
      // or the customer-state event below, not a replay of the page's scripts.
      next.querySelectorAll('script:not([type="application/json"]):not([data-mega-panel])').forEach((script) => script.remove());
      return { current, next };
    });

    window.customer = state.customer;
    document.getElementById('NeCustomerState').textContent = JSON.stringify(state);
    document.body.classList.add('is-logged');
    for (const { current, next } of updates) {
      current.dispatchEvent(new CustomEvent('shopify:section:unload', { bubbles: true }));
      // Keep mounted WebGL canvases and their controllers while text updates.
      const placeholders = Array.from(next.querySelectorAll('[data-auth-preserve]'));
      current.querySelectorAll('[data-auth-preserve]').forEach((kept) => {
        const placeholder = placeholders.find((node) => node.dataset.authPreserve === kept.dataset.authPreserve);
        if (placeholder) placeholder.replaceWith(kept);
      });
      for (const { name, value } of Array.from(next.attributes)) current.setAttribute(name, value);
      current.replaceChildren(...Array.from(next.childNodes));
      current.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
    }
    // Header panel data is inert NDJSON; the existing React header recollects it.
    const panels = Array.from(html.querySelectorAll('script[data-mega-panel]'));
    document.querySelectorAll('script[data-mega-panel]').forEach((current) => {
      const next = panels.find((node) => node.dataset.megaPanel === current.dataset.megaPanel);
      if (next) current.textContent = next.textContent;
    });
    document.querySelectorAll('[data-auth-open="login"], [data-auth-open="register"]').forEach((link) => {
      if (link instanceof HTMLAnchorElement) link.href = state.accountUrl;
      link.removeAttribute('data-auth-open');
    });
    window.dispatchEvent(new CustomEvent('ne:customer-state', { detail: state }));
    if (window.Shopify?.PaymentButton?.init) window.Shopify.PaymentButton.init();
    return state;
  }

  window.NECustomerSession = {
    refresh() {
      if (!pending) pending = refreshPage().finally(() => { pending = null; });
      return pending;
    },
  };
})();
